@for (item of categories; track item; let indexOfFilterCategory = $index) {
  <div class="filter-category" data-cy="filter-popups">
    @if (!item.name.includes('_')) {
      <div>
        <button [disabled]="disableButton(item)" mat-flat-button class="filter-button" data-cy="filter-btn" id="{{ item.name }}" (click)="openPopup(indexOfFilterCategory, item)" [class.active]="item.activeFlag">
          {{ item.name }}
        </button>

        @if (indexOfFilterCategory === indexOfSelectedFilterButton) {
          <app-filter-popup
            [title]="item.name"
            [maxEndDate]="maxEndDate"
            [options]="item.data"
            [item]="item"
            [rightJustify]="indexOfFilterCategory >= 2"
            (popupCancel)="closePopup($event, item)"
            [isDateSelected]="isDateSelected"
            [useDatepickerDateRange]="useDatepickerDateRange"
            [isRenderedInModal]="isRenderedInModal"
            [checklist]="false"
            [datesToEnable]="dates"
            (categoryFilterChanged)="categoryDirtyChange($event)"
            (dateFilterChanged)="dateDirtyChange($event)"
            (filterCleared)="filterCleared($event)"
            (selectedMonths)="selectedMonths($event)"
          >
          </app-filter-popup>
        }
      </div>
    }
  </div>
}
